import { Disparity } from '../types/Disparity/Disparity.type';
import { DisparityWithCounts } from '../types/Disparity/DisparityWithCounts.type';

export const hasDisparityCounts = (disparity: Disparity): disparity is DisparityWithCounts =>
  disparity.comparison_denominator != null &&
  disparity.comparison_numerator != null &&
  disparity.target_denominator != null &&
  disparity.target_numerator != null;
